import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { RequestManagementService } from '../services/request-management.service';
import { UserService } from '../services/user.service';
import 'rxjs/add/operator/map';
import { ServerParameterModel, DealsWizardModel, DealModel, SavePageRequestModel, GetDealsRequestModel, DealCustomModel ,CreditCardYearModel} from '../_models/_index';

@Injectable()
export class DealService {

    constructor(private requestManagement: RequestManagementService,
       private userService:UserService) { }

    public getDealByID(dealID: number, serviceTypeID: number): Promise<DealsWizardModel> {
        
        return this.requestManagement.callGetRequest('deals/getDealByID', {
            "dealID": dealID, "serviceTypeID": serviceTypeID}).map((response: Response) => {
            return <DealsWizardModel>response.json();
        }).toPromise();
    }


    public getDealByDealKey(dealKey: string, serviceTypeID: number): Promise<DealsWizardModel> {

        return this.requestManagement.callGetRequest('deals/getDealByDealKey', {
            "dealKey": dealKey, "serviceTypeID": serviceTypeID
        }).map((response: Response) => {
            return <DealsWizardModel>response.json();
        }).toPromise();
    }
    public getCreditCardYearList(): Promise<CreditCardYearModel[]>
    {
        return this.requestManagement.callGetRequest('deals/getCreditCardYearList',null).map((response: Response) => {
            return <CreditCardYearModel[]>response.json();
        }).toPromise();
    }

    public duplicateDeal(sourceDealID: number): Promise<DealsWizardModel> {
        let param: ServerParameterModel = new ServerParameterModel();
        param.parameterName = "sourceDealID";
        param.parameterValue = sourceDealID;
        return this.requestManagement.callGetRequest('deals/duplicateDeal', { "sourceDealID": sourceDealID }).map((response: Response) => {
            return <DealsWizardModel>response.json();
        }).toPromise();
    }

    public duplicateSignedDeal(sourceDealID: number): Promise<DealsWizardModel> {
        let param: ServerParameterModel = new ServerParameterModel();
        param.parameterName = "sourceDealID";
        param.parameterValue = sourceDealID;
        return this.requestManagement.callGetRequest('deals/duplicateSignedDeal', { "sourceDealID": sourceDealID }).map((response: Response) => {
            return <DealsWizardModel>response.json();
        }).toPromise();
    }

    public sendDealPDF(dealKey: string, emailAddress: string, companyName: string, serviceTypeID:number): Promise<boolean> {
        return this.requestManagement.callGetRequest('deals/createDealPDFByDealKey'
            , {
                'dealKey': dealKey,
                'emailAddress': emailAddress,
                'companyName': companyName,
                'serviceTypeID': serviceTypeID
            }
        ).map((response: Response) => {
            return <boolean>response.json();
        }).toPromise();
    }

    //public createDealPDF2Preview(dealID: number, emailAddress: string, companyName: string): Promise<any> {
    //    return this.requestManagement.callGetRequestFile('deals/createDealPDF2Preview'
    //        , {
    //            'dealID': dealID,
    //            'emailAddress': emailAddress,
    //            'companyName': companyName
    //        }
    //    ).map((response: Response) => {
    //        return <any>response;
    //    }).toPromise();
    //}

    downloadPDF(dealKey: string, serviceTypeID: number): any
    {
        return this.requestManagement.callGetRequest('deals/createDealPDF2PreviewByDealKey'
            , {
                'dealKey': dealKey,
                'serviceTypeID': serviceTypeID

            }
        ).map((response: Response) => {
            return response;
        });
    }


    public savePageNumber(model: SavePageRequestModel): Promise<boolean> {
        return this.requestManagement.callPostRequest('deals/savePageNumber', model).map((response: Response) => {
            return <boolean>response.json();
        }).toPromise();
    }

    public saveStatus(model: SavePageRequestModel): Promise<boolean> {
        return this.requestManagement.callPostRequest('deals/saveStatus', model).map((response: Response) => {
            return <boolean>response.json();
        }).toPromise();
    }

    public getDeals(request: GetDealsRequestModel): Promise<DealCustomModel[]> { 
        request.userId = this.userService.getCurrentUser().id;   
        return this.requestManagement.callPostRequest('deals/getDeals', request).map((response: Response) => {
            return <DealCustomModel[]>response.json();
        }).toPromise();
    }

    public saveDeal(dealWizard: DealsWizardModel): Promise<DealsWizardModel> {

        return this.requestManagement.callPostRequest('deals/saveDeal', dealWizard).map((response: Response) => {
            return <DealsWizardModel>response.json();
        }).toPromise();
    }

    public checkCreditCardInput(dealWizard: DealsWizardModel): Promise<DealsWizardModel> {

        return this.requestManagement.callPostRequest('deals/checkCreditCardInput', dealWizard).map((response: Response) => {
            return <DealsWizardModel>response.json();
        }).toPromise();
    }

    public emailSendDeal(deal: DealModel): Promise<boolean> {
        return this.requestManagement.callPostRequest('deals/emailSendDeal', deal).map((response: Response) => {
            return <boolean>response.json();
        }).toPromise();
    }

    public emailSendPayment(deal: DealModel): Promise<boolean> {
        return this.requestManagement.callPostRequest('deals/emailSendPayment', deal).map((response: Response) => {
            return <boolean>response.json();
        }).toPromise();
    }

    public cancelDeal(deal: DealModel): Promise<boolean> {

        return this.requestManagement.callPostRequest('deals/cancelDeal', deal).map((response: Response) => {
            return <boolean>response.json();
        }).toPromise();
    }


    public makeFileRequest(url: string, file2upload: File) {
        url = this.requestManagement.getBaseUrl() + url;
        return new Promise((resolve, reject) => {
            var formData: any = new FormData();
            var xhr = new XMLHttpRequest();
            //for (var i = 0; i < files.length; i++) {
            formData.append("uploads", file2upload, file2upload.name);
            //  }
            xhr.onreadystatechange = function () {
                if (xhr.readyState == XMLHttpRequest.DONE) {
                    if (xhr.status == 200) {
                        if (xhr.response == "") {
                            resolve(true);
                        } else {
                            resolve(JSON.parse(xhr.response));
                        }
                    } else {
                        reject(xhr.response);
                    }
                }
            }
            xhr.open("POST", url, true);
            xhr.send(formData);
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/deal.service.ts